<template>
    <b-form ref="settings_form" @submit="handleSettings">
        <b-row class="mr-4 ml-4 mb-4 mt-4" align-h="between">
            <b-col md="8" offset-md="2">
                <b-card>
                    <template #header>
                        <b-img src="/static/defect-dojo-favicon.ico" width="20" height="20"/>
                        <strong class="ml-2 mr-2">Defect-Dojo</strong>
                    </template>
                    <b-row class="mb-3">
                        <b-col sm="2">
                            <label>URL</label>
                        </b-col>
                        <b-col sm="7">
                            <b-form-input type="text" v-model="defectDojoUrl" placeholder="Defect-Dojo URL" :state="defectDojoUrlState"/>
                        </b-col>
                        <b-col sm="3">
                            <b-icon icon="check-circle-fill" variant="success" v-if="defectDojoEnabled"/>
                            <b-icon icon="x-circle-fill" variant="danger" v-if="!defectDojoEnabled"/>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col sm="2">
                            <label>API ключ</label>
                        </b-col>
                        <b-col sm="7">
                            <b-form-input type="password" v-model="defectDojoApiKey" placeholder="Defect-Dojo API ключ"  @change="defectDojoApiKeyChanged = true" :state="defectDojoApiKeyState"/>
                        </b-col>
                        <b-col sm="3">
                            <b-form-checkbox v-model="defectDojoVerifyTls">Проверка TLS</b-form-checkbox>
                        </b-col>
                    </b-row>
                    <hr/>
                    <b-row>
                        <b-col lg="6">
                            <b-row class="mb-3">
                                <b-col sm="4">
                                    <label>Тег</label>
                                </b-col>
                                <b-col sm="8">
                                    <b-form-input type="text" v-model="defectDojoTag" placeholder="Тег Defect-Dojo" :state="defectDojoTagState"/>
                                </b-col>
                            </b-row>
                            <b-row>
                                <b-col sm="4">
                                    <label>Тип теста</label>
                                </b-col>
                                <b-col sm="8">
                                    <b-form-input type="text" v-model="defectDojoTestType" placeholder="Тип теста Defect-Dojo" :state="defectDojoTestTypeState"/>
                                </b-col>
                            </b-row>
                        </b-col>
                        <b-col lg="6">
                            <b-row class="mb-3">
                                <b-col sm="4">
                                    <label>Тип продукта</label>
                                </b-col>
                                <b-col sm="8">
                                    <b-form-input type="text" v-model="defectDojoProductType" placeholder="Тип продукта Defect-Dojo" :state="defectDojoProductTypeState"/>
                                </b-col>
                            </b-row>
                            <b-row>
                                <b-col sm="4">
                                    <label>Тест</label>
                                </b-col>
                                <b-col sm="8">
                                    <b-form-input type="text" v-model="defectDojoTest" placeholder="Тест Defect-Dojo" :state="defectDojoTestState"/>
                                </b-col>
                            </b-row>
                        </b-col>
                    </b-row>
                </b-card>
                <br/>
                <b-card>
                    <template #header>
                        <b-icon icon="envelope-fill" variant="info"/>
                        <strong class="ml-2 mr-2">Email (SMTP)</strong>
                        <b-icon icon="check-circle-fill" variant="success" v-if="emailEnabled" class="ml-2"/>
                        <b-icon icon="x-circle-fill" variant="danger" v-if="!emailEnabled" class="ml-2"/>
                        <b-button v-if="emailEnabled" size="sm" variant="outline-info" class="ml-3" v-b-modal.test-email-modal>Отправить тест</b-button>
                    </template>
                    <b-row>
                        <b-col sm="2">
                            <label>Хост</label>
                        </b-col>
                        <b-col sm="7">
                            <b-form-input type="text" v-model="emailHost" placeholder="smtp.example.com" :state="emailHostState"/>
                        </b-col>
                        <b-col sm="3">
                            <b-form-input type="number" v-model="emailPort" placeholder="Порт" :state="emailPortState"/>
                        </b-col>
                    </b-row>
                    <b-row class="mt-2">
                        <b-col sm="2">
                            <label>Пользователь</label>
                        </b-col>
                        <b-col sm="7">
                            <b-form-input type="text" v-model="emailUser" placeholder="SMTP пользователь (email)"/>
                        </b-col>
                        <b-col sm="3">
                            <b-form-checkbox v-model="emailTls">STARTTLS</b-form-checkbox>
                        </b-col>
                    </b-row>
                    <b-row class="mt-2">
                        <b-col sm="2">
                            <label>Пароль</label>
                        </b-col>
                        <b-col sm="7">
                            <b-form-input type="password" v-model="emailPassword" placeholder="SMTP пароль" @change="emailPasswordChanged = true" :state="emailPasswordState"/>
                        </b-col>
                        <b-col sm="3"/>
                    </b-row>
                    <b-row class="mt-2">
                        <b-col sm="2">
                            <label>От кого</label>
                        </b-col>
                        <b-col sm="7">
                            <b-form-input type="email" v-model="emailFrom" placeholder="Fix Audit <[email protected]>" :state="emailFromState"/>
                        </b-col>
                        <b-col sm="3"/>
                    </b-row>
                    <b-row v-if="!emailEnabled" class="mt-3">
                        <b-col sm="9" offset-sm="2">
                            <b-alert variant="warning" show>
                                <b-icon icon="exclamation-triangle-fill"/>
                                <span class="ml-2">Укажите хост и порт SMTP-сервера, чтобы включить отправку email-уведомлений (приглашения, сброс пароля, уведомления о находках).</span>
                            </b-alert>
                        </b-col>
                    </b-row>
                </b-card>
                <b-card>
                    <template #header>
                        <b-icon icon="shield-lock-fill" variant="danger"/>
                        <strong class="ml-2 mr-2">Безопасность</strong>
                    </template>
                    <b-row>
                        <b-col sm="3">
                            <label>Макс. МБ для загрузки файлов</label>
                        </b-col>
                        <b-col sm="9">
                            <b-input-group :prepend="uploadFilesMaxMb.toString()">
                                <b-form-input v-model="uploadFilesMaxMb" type="range" min="128" max="1024" :state="uploadFilesMaxMbState"/>
                            </b-input-group>
                        </b-col>
                    </b-row>
                </b-card>
            </b-col>
        </b-row>
        <b-row class="mb-3" align-h="center">
            <b-button type="submit" variant="dark" size="lg">Сохранить</b-button>
        </b-row>
        <test-email-modal id="test-email-modal"/>
    </b-form>
</template>

<script>
import RekonoApi from '@/backend/RekonoApi';
import TestEmailModal from '@/modals/TestEmail.vue';
export default {
    name: 'settingsPage',
    mixins: [RekonoApi],
    components: { TestEmailModal },
    data () {
        if (this.$store.state.role !== 'Admin') {
            this.$router.push('/')
        }
        this.getSettings()
        return {
            uploadFilesMaxMb: null,
            uploadFilesMaxMbState: null,
            defectDojoUrl: null,
            defectDojoUrlState: null,
            defectDojoApiKey: null,
            defectDojoApiKeyChanged: false,
            defectDojoApiKeyState: null,
            defectDojoVerifyTls: null,
            defectDojoTag: null,
            defectDojoTagState: null,
            defectDojoProductType: null,
            defectDojoProductTypeState: null,
            defectDojoTestType: null,
            defectDojoTestTypeState: null,
            defectDojoTest: null,
            defectDojoTestState: null,
            defectDojoEnabled: null,
            emailHost: null,
            emailHostState: null,
            emailPort: null,
            emailPortState: null,
            emailUser: null,
            emailTls: null,
            emailPassword: null,
            emailPasswordChanged: false,
            emailPasswordState: null,
            emailFrom: null,
            emailFromState: null,
            emailEnabled: null,
        }
    },
    methods: {
        processResponse (data) {
            this.uploadFilesMaxMb = data.upload_files_max_mb
            this.defectDojoUrl = data.defect_dojo_url
            this.defectDojoApiKey = data.defect_dojo_api_key
            this.defectDojoApiKeyChanged = false
            this.defectDojoVerifyTls = data.defect_dojo_verify_tls
            this.defectDojoTag = data.defect_dojo_tag
            this.defectDojoProductType = data.defect_dojo_product_type
            this.defectDojoTestType = data.defect_dojo_test_type
            this.defectDojoTest = data.defect_dojo_test
            this.defectDojoEnabled = data.defect_dojo_enabled
            this.emailHost = data.email_host
            this.emailPort = data.email_port
            this.emailUser = data.email_user
            this.emailPassword = data.email_password
            this.emailPasswordChanged = false
            this.emailTls = data.email_tls
            this.emailFrom = data.email_from
            this.emailEnabled = data.email_enabled
        },
        getSettings () {
            this.get('/api/system/1/').then(response => this.processResponse(response.data))
        },
        checkSettings () {
            this.defectDojoUrlState = null
            this.defectDojoTagState = null
            this.defectDojoProductTypeState = null
            this.defectDojoTestTypeState = null
            this.defectDojoTestState = null
            this.defectDojoApiKeyState = null
            this.emailHostState = null
            this.emailPortState = null
            this.emailFromState = null
            this.emailPasswordState = null
            if (this.defectDojoUrl && !this.validateUrl(this.defectDojoUrl)) {
                this.defectDojoUrlState = false
            }
            if (this.defectDojoTag && !this.validateName(this.defectDojoTag)) {
                this.defectDojoTagState = false
            }
            if (this.defectDojoProductType && !this.validateName(this.defectDojoProductType)) {
                this.defectDojoProductTypeState = false
            }
            if (this.defectDojoTestType && !this.validateName(this.defectDojoTestType)) {
                this.defectDojoTestTypeState = false
            }
            if (this.defectDojoTest && !this.validateName(this.defectDojoTest)) {
                this.defectDojoTestState = false
            }
            if (this.defectDojoApiKeyChanged && this.defectDojoApiKey && !this.validateDefectDojoKey(this.defectDojoApiKey)) {
                this.defectDojoApiKeyState = false
            }
            // Email validations
            if (this.emailHost && !this.validateName(this.emailHost)) {
                this.emailHostState = false
            }
            if (this.emailPort && (this.emailPort < 1 || this.emailPort > 65535)) {
                this.emailPortState = false
            }
            if (this.emailFrom && !this.validateEmail(this.emailFrom)) {
                this.emailFromState = false
            }
            return (this.defectDojoUrlState != false && this.defectDojoTagState != false && this.defectDojoProductTypeState != false && this.defectDojoTestTypeState != false && this.defectDojoTestState != false && this.defectDojoApiKeyState != false && this.emailHostState != false && this.emailPortState != false && this.emailFromState != false && this.emailPasswordState != false)
        },
        handleSettings (event) {
            event.preventDefault()
            if (this.checkSettings()) {
                let data = {
                    upload_files_max_mb: this.uploadFilesMaxMb,
                    defect_dojo_url: this.defectDojoUrl,
                    defect_dojo_verify_tls: this.defectDojoVerifyTls,
                    defect_dojo_tag: this.defectDojoTag,
                    defect_dojo_product_type: this.defectDojoProductType,
                    defect_dojo_test_type: this.defectDojoTestType,
                    defect_dojo_test: this.defectDojoTest,
                    email_host: this.emailHost,
                    email_port: this.emailPort ? parseInt(this.emailPort) : null,
                    email_user: this.emailUser,
                    email_tls: this.emailTls,
                    email_from: this.emailFrom,
                }
                if (this.defectDojoApiKeyChanged) {
                    data.defect_dojo_api_key = this.defectDojoApiKey
                }
                if (this.emailPasswordChanged) {
                    data.email_password = this.emailPassword
                }
                this.put('/api/system/1/', data, 'Настройки', 'Настройки обновлены успешно')
                    .then(data => this.processResponse(data))
            }
        }
    }
}
</script>
